import { render, staticRenderFns } from "./AddEditSession.vue?vue&type=template&id=cd0387c6"
import script from "./AddEditSession.vue?vue&type=script&lang=js"
export * from "./AddEditSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports